import {  KoButton, KoForm, KoLoader,  KoModal,  KoPagination, KoTable } from 'packages';
import React, { useState } from 'react';
import styles from "./recurringBills.module.scss";
import KoToolBar from 'shared/components/toolbar';
import { COLUMNS_GROUPS, ROW_DATA } from "./constant";
import KoIcon from '@kwapio/icons';
import RecurringBillsCurd from './recurringBills';

const RecurringBills= () => {
  const [form] = KoForm.useForm();
  const [isModalRecurringBills,setModalRecurringBills]=useState(false);
  const [isLoading] = useState(false);
  const [totalCount] = useState(0);
  const [pagination, setPagination] = useState({
    size: 10,
    offset: 0,
    page: 1
  });
    



  const onPagination = (page, other) => {
    const query = {
      size: other,
      page: page

    };
    const p = Object.assign(pagination, query);
    setPagination(p);
  };
  return (
    <div className={styles.wrapper}>
      {isLoading && <KoLoader/>}

      <div className={`tableCard`}>
        <KoToolBar
          title={''}
          search={{ visible: true, onChange: () => { }, placeholder: 'Search by any parameter' }}
          filter={{
            visible: false,
            options: [{ label: 'Sort By Name', key: '0' },
              { label: 'Created At', key: '2' },
              { label: 'Sort By designation', key: '3' }]
          }}
          buttonList={[{
            label: 'Create',
            type: 'primary',
            icon: <KoIcon color="#FFF" name="PlusOutlined" width={18} height={18} />, onClick: () => setModalRecurringBills(true)
          }]}   />

        <KoTable data={{ columns: COLUMNS_GROUPS, rows:ROW_DATA }}
          maxHeight={50} />
        <KoPagination current={parseInt(pagination.page) || 1}
          total={totalCount}
          showTotal={(total, range) =>
            `${range[0]}-${range[1]} of ${total} records`
          }
          pageSize={pagination.limit}
          defaultCurrent={pagination.page}
          onChange={onPagination}
          showQuickJumper={false}
          simple={false}
          responsive={false} />
      </div>

      <KoModal
        title={`Recurring Bills`}
        open={isModalRecurringBills}
        centered
        afterClose={() => { form.resetFields();  }}
        handleOk={() => { setModalRecurringBills(false); }}
        onClose={() => { setModalRecurringBills(false); form.resetFields(); }}
        width={'40vw'}
        maskClosable={false}
        footer={[
          <KoButton key='cancel' label='Cancel' onClick={() => { setModalRecurringBills(false); form.resetFields(); }} />,
          <KoButton key='create' loading={isLoading} type='primary' label={`Create`}
            onClick={() => form.submit()} />
        ]}
      >
        {isLoading && <KoLoader circle={false} />}
        <RecurringBillsCurd/>
      </KoModal>
    </div>
  );
};

export default RecurringBills;